import { connect } from "react-redux";
import { compose } from 'recompose';
import * as Yup from "yup";
import { t } from 'i18next';


import { appActions } from "../../../../modules/app";
import { withForm } from "../../../../utils/enhancers";
import ContactFormComponent from "./contacFormComponent";
import { withLanguageOnChange } from "../../../../utils/enhancers/withLanguageChange";

const { createContactsMessage } = appActions;


export const ContactFormContainer = compose(
  connect(() => ({}), { createContactsMessage }),
  withLanguageOnChange,
  withForm({
    mapPropsToValues: () => ({
      name: '',
      email: '',
      text: '',
    }),
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .required(t('contactsPage.form.errors.nameRequired')),
      email: Yup.string()
        .email(t('contactsPage.form.errors.isNotValid'))
        .required(t('contactsPage.form.errors.emailRequired')),
      text: Yup.string()
        .required(t('contactsPage.form.errors.textRequired')),
    }),
    handleSubmit: ( values, { setSubmitting, props: { createContactsMessage } }) => {

      setSubmitting(true);

      createContactsMessage(values);
    },
  }),
)(ContactFormComponent);
